import {forEach} from "lodash";

export class PaginationController {
    public permalink: any;
    public limit: number;
    public offset: number = 0;
    public total: number;
    public data: any;
    public watcher: any;
    public loading: boolean;
    public getData: any;

    public static $inject = ["$location"];
    constructor(private $location: angular.ILocationService) {

    }

    public setLoading(loading: boolean) {
        this.loading = loading;
    }

    public setOffset(offset: number) {
        this.offset = offset;
    }

    public setTotal(total: number) {
        this.total = total;
    }

    public setLimit(limit: number) {
        this.limit = limit;
    }

    public setData(data: number) {
        this.data = data;
    }

    public cleanUpPermalinks(ignore: string) {
        forEach(Object.keys(this.permalink), (permalinkKey: string) => {
            if (permalinkKey !== ignore) {
                this.$location.search(this.permalink[permalinkKey], null);
            }
        });
    }
}